/**
 * The name of the component that threw, from the first frame of React's
 * component stack: `at ConnectorList (https://…/index.js:12:345)` in Chrome,
 * `ConnectorList@https://…` in Firefox. Null when the frame carries no name.
 * The bundle location is dropped: the event only needs which component it was.
 */
export function componentName(stack: string | null | undefined): string | null {
  const frame = (stack?.trim().split("\n")[0]?.trim() ?? "").replace(/^(?:at|in)\s+/, "");
  const m = /^([A-Za-z_][\w.]*)(?=\s|\(|@|$)/.exec(frame);
  return m ? m[1].slice(0, 80) : null;
}
